import React from "react";

const Section5 = ({ url }) => {

const steps = [
  {
    side: "left",
    number: "1",
    title: "Discovery Call (Free)",
    desc: "We start by understanding your business operations, the specific problem you want AI to solve, and what success actually looks like in your context. Not every problem needs AI, and we will tell you that directly if it does not.",
  },
  {
    side: "right",
    number: "2",
    title: "AI Feasibility & Solution Design",
    desc: "Before we scope or cost anything, we assess feasibility: your data readiness, integration requirements, the right model or automation approach, and a realistic impact estimate. You receive a solution design document before any code is written.",
  },
  {
    side: "left",
    number: "3",
    title: "Proof of Concept (Where Required)",
    desc: "For novel or high-complexity AI implementations, we build a contained proof of concept to validate the approach before committing to full development. This protects your investment and eliminates the 'impressive demo, failed deployment' failure mode.",
  },
  {
    side: "right",
    number: "4",
    title: "Iterative Development & Integration",
    desc: "Development happens in visible, reviewable cycles. You see the AI performing against your real data at each stage, not just at delivery. Integration with your existing systems is handled within the build, not added as an afterthought.",
  },
  {
    side: "left",
    number: "5",
    title: "Testing, Validation & Edge Case Handling",
    desc: "AI systems must be stress-tested against real-world conditions, not just ideal scenarios. We test for accuracy, edge cases, failure modes, and bias before any system goes near a production environment.",
  },
  {
    side: "right",
    number: "6",
    title: "Deployment, Documentation & Training",
    desc: "We deploy, document every component, and train your team so they understand what the system does, what it does not do, and how to manage it. You are never dependent on us to operate what we built.",
  },
  {
    side: "left",
    number: "7",
    title: "Monitoring, Iteration & Ongoing Support",
    desc: "AI systems degrade over time if not maintained. We offer structured monitoring and iteration cycles post-deployment to keep your system performing as your data and operations evolve.",
  },
];

  return (
    <section className="home-section-5">
      <div className="container">

        <h2 className="s5-title" data-aos="fade-up">Our AI Development Process</h2>
        <p className="s5-subtitle" data-aos="fade-up" data-aos-delay="100">
          AI projects fail most often at the problem definition stage, not the technical stage. Our
          process starts there deliberately. We do not begin writing code until we are certain the
          problem is worth solving the way we intend to solve it.
        </p>

        <div className="s5-timeline">

          {/* center vertical line */}
          <div className="s5-timeline-line" />

          {steps.map((step, idx) => (
            <div
              className={`s5-step s5-step--${step.side}`}
              key={idx}
              data-aos={step.side === "left" ? "fade-right" : "fade-left"}
              data-aos-delay={idx * 100}
            >
              {/* card */}
              <div className="s5-card">
                <h3 className="s5-card-title">{step.title}</h3>
                <p className="s5-card-desc">{step.desc}</p>
              </div>

              {/* number badge */}
              <div className="s5-badge">{step.number}</div>

            </div>
          ))}

        </div>
      </div>
    </section>
  );
};

export default Section5;